import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initSetProfile, setPrfoile } from "../redux/actions";
import { authUser } from "../redux/selectors/authSelectors";
import { useNavigate } from "react-router-dom";

const useEditProfile = (user) => {
  const storageUser = useSelector(authUser);
  const { setProfileSuccess, error } = useSelector((state) => state.profileReducer);
  const [confirmationError, setConfirmationError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState(false)
  const addressRef = useRef(null);
  const navigate = useNavigate();
  const { role } = storageUser || {};
  const [fullName, setFullName] = useState(
    user?.first_name || user?.last_name
      ? `${user?.first_name} ${user?.last_name}`
      : ""
  );
  const ages = [
    15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
    34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
    53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
    72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
  ];
  const [address, setAddress] = useState(user?.address ? user.address : "");
  const [zipcode, setZipCode] = useState(user?.zipcode ? user.zipcode : "");
  const [careers, setCareers] = useState(user?.careers ? user.careers : "");
  const [certainty, setCertainty] = useState(
    user?.certainty ? user.certainty : null
  );
  const [aboutMe, handleAboutMe] = useState(user?.about_me || "");
  const [age, setAge] = useState(user?.age ? user.age : 0);
  const [email, setEmail] = useState(user?.email ? user.email : "");
  const [phone, setPhone] = useState(user?.phone ? user.phone : "");
  const [isCloseModalOpened, setCloseMOdalIsOPened] = useState(false);
  const [isAgeListOpened, setIsageListOpened] = useState(false);
  const [city, setCity] = useState(user?.city ? user.city : "");
  const [country, setCountry] = useState(user?.country ? user.country : "");
  const [state, setState] = useState(user?.state ? user.state : "");
  const [formState, setFormState] = useState({
    grade: user?.grade ? user.grade : "",
    education: user?.education ? user.education : "",
  })
  const dispatch = useDispatch();
  const countryRef = useRef(null);
  const [errors, setErrors] = useState({});
  const validationRules = {
    fullName: [
      { check: (v) => safeTrim(v) !== "", message: "Full name is required" },
    ],
    email: [
      { check: (v) => safeTrim(v) !== "", message: "Email is required" },
      {
        check: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
        message: "Invalid email format",
      },
    ],
    phone: [
      { check: (v) => safeTrim(v) !== "", message: "Phone number is required" },
    ],
    address: [{ check: (v) => v.trim() !== "", message: "Address is required" }],
    zipcode: [
      { check: (v) => safeTrim(v) !== "", message: "Zipcode is required" },
    ],
    state: [{ check: (v) => safeTrim(v) !== "", message: "State is required" }],
    city: [{ check: (v) => safeTrim(v) !== "", message: "City is required" }],
    aboutMe: role !== "Student"
      ? [{ check: (v) => safeTrim(v) !== "", message: "About Me is required" }]
      : [],
    grade: role === "Student"
      ? [{ check: (v) => safeTrim(v) !== "", message: "Grade is required" }]
      : [],
    education: role === "Student"
      ? [{ check: (v) => safeTrim(v) !== "", message: "Education is required" }]
      : [],
  };

  const safeTrim = (val) => {
    if (val === null || val === undefined) return "";
    return String(val).trim();
  };
  useEffect(() => {
    if (setProfileSuccess) {
      setPasswordSuccess(true);
      setConfirmationError('')
      setTimeout(() => {
        setPasswordSuccess(false);
        dispatch(setPrfoile())
        navigate("/profile/profile-info");
      }, 3000);
    }
    console.log(error);

    if (error?.email?.length) {
      setConfirmationError(error?.email[0]);
    }
  }, [setProfileSuccess, error, navigate]);
  useEffect(() => {
    const autocomplete = new window.google.maps.places.Autocomplete(
      addressRef.current,
      { types: ["geocode"] }
    );
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      setAddress(place.formatted_address);

      const addressComponents = place.address_components;
      for (let i = 0; i < addressComponents.length; i++) {
        const addressType = addressComponents[i].types[0];
        if (addressType === "locality") {
          setCity(addressComponents[i].long_name);
        } else if (addressType === "postal_code") {
          setZipCode(addressComponents[i].long_name);
        } else if (addressType === "administrative_area_level_1") {
          setState(addressComponents[i].long_name);
        } else if (addressType === "country") {
          setCountry(addressComponents[i].long_name);
        }
      }
    });
  }, []);
  useEffect(() => {
    setFullName(
      user?.first_name || user?.last_name
        ? `${user?.first_name} ${user?.last_name}`
        : ""
    );
    setAddress(user?.address ? user.address : "");
    setZipCode(user?.zipcode ? user.zipcode : "");
    setCareers(user?.careers ? user.careers : "");
    setCertainty(
      user?.certainty ? user.certainty : null
    );
    handleAboutMe(user?.about_me || "");
    setAge(user?.age ? user.age : 0);
    setEmail(user?.email ? user.email : "");
    setPhone(user?.phone ? user.phone : "");
    setCloseMOdalIsOPened(false);
    setIsageListOpened(false);
    setCity(user?.city ? user.city : "");
    setCountry(user?.country ? user.country : "");
    setState(user?.state ? user.state : "");
    setFormState({
      grade: user?.grade ? user.grade : "",
      education: user?.education ? user.education : "",
    })
  }, [user])
  const handleCountry = (e) => {
    setCountry(e.target.value);
  };
  const handleAddress = (e) => {
    setAddress(e.target.value);
    // const autocomplete = new window.google.maps.places.Autocomplete(
    //   addressRef.current,
    //   { types: ["geocode"] }
    // );
    // autocomplete.addListener("place_changed", () => {

    //   const place = autocomplete.getPlace();
    //   setAddress(place.formatted_address);

    //   const addressComponents = place.address_components;
    //   for (let i = 0; i < addressComponents.length; i++) {
    //     const addressType = addressComponents[i].types[0];
    //     if (addressType === "locality") {
    //       setCity(addressComponents[i].long_name);
    //     } else if (addressType === "postal_code") {
    //       console.log(addressComponents[i].long_name, " zip code");
    //       setZipCode(addressComponents[i].long_name);
    //     } else if (addressType === "administrative_area_level_1") {
    //       setState(addressComponents[i].long_name);
    //     } else if (addressType === "country") {
    //           setCountry(addressComponents[i].long_name)
    //     }
    //   }
    // });
  };
  const openCloseModal = () => {
    setCloseMOdalIsOPened(true);
  };

  const closeCloseModal = () => {
    setCloseMOdalIsOPened(false);
  };
  const handleFullName = (e) => {
    setFullName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handlePhone = (e) => {
    setPhone(e.target.value);
  };
  const handleZipCode = (e) => {
    setZipCode(e.target.value);
  };
  const handleState = (e) => {
    setState(e.target.value);
  };
  const handleCity = (e) => {
    setCity(e.target.value);
  };
  const validate = () => {
    const newErrors = {};

    Object.entries(validationRules).forEach(([field, rules]) => {
      const value = {
        fullName,
        email,
        phone,
        address,
        zipcode,
        country,
        state,
        city,
        aboutMe,
        grade: formState.grade,
        education: formState.education,
        careers,
        certainty,
      }[field];

      for (let rule of rules) {
        if (!rule.check(value)) {
          newErrors[field] = rule.message;
          break; // stop after first error
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const updateProfile = () => {
    if (!validate()) return;
    const param = { ...user }
    delete param.affiliate_code
    delete param.profile_image
    const [firstName, ...rest] = fullName.trim().split(" ").filter(Boolean);
    const lastName = rest.join(" ");
    dispatch(
      initSetProfile(
        role === "Student"
          ? {
            ...param,
            address,
            email,
            age,
            certainty,
            careers,
            zipcode,
            phone,
            state,
            country,
            ...formState,
            city,
            first_name: firstName,
            last_name: lastName,
          }
          : {
            ...param,
            age,
            address,
            email,
            zipcode,
            phone,
            state,
            country,
            city,
            about_me: aboutMe,
            first_name: firstName,
            last_name: lastName,
          }
      )
    );
  };
  const openAgeList = () => {
    setIsageListOpened(true);
  };
  const CloseAgeList = () => {
    setIsageListOpened(false);
  };
  const removeChanges = () => {
    setEmail("");
    setAge("");
    setFullName("");
    setPhone("");
    setZipCode("");
    setAddress("");
    setCountry("");
    setState("");
    setCity("");
    setFormState({
      grade: "",
      education: "",
    })
    setCloseMOdalIsOPened(false);
    navigate("/profile/profile-info");
  };
  const handleAge = (num) => {
    setAge(Number(num));
    CloseAgeList();
  };
  return {
    fullName,
    errors,
    isCloseModalOpened,
    age,
    email,
    phone,
    zipcode,
    address,
    isAgeListOpened,
    ages,
    role,
    addressRef,
    countryRef,
    country,
    state,
    city,
    aboutMe,
    formState,
    confirmationError,
    handleAboutMe,
    closeCloseModal,
    openCloseModal,
    updateProfile,
    removeChanges,
    handleFullName,
    handleEmail,
    handlePhone,
    handleZipCode,
    handleAddress,
    openAgeList,
    CloseAgeList,
    handleAge,
    handleCountry,
    handleState,
    handleCity,
    setFormState,
    careers,
    passwordSuccess,
    setCareers,
    certainty,
    setCertainty,
  };
};

export default useEditProfile;
